// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fancy-scroll--view::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n", "",{"version":3,"sources":["webpack://./node_modules/@influxdata/react-custom-scrollbars/dist/styles.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,SAAS;AACX","sourcesContent":[".fancy-scroll--view::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
